import { CountedTranslation } from '@app/models';

export const membersCount: CountedTranslation = (count: number) => {
    if (count === 1) {
        return 'ONE_MEMBER';
    } else if (count === 0) {
        return 'NO_MEMBERS';
    }
    return 'MEMBERS';
};

export const vaultsCount: CountedTranslation = (count: number) => {
    if (count === 1) {
        return 'ONE_VAULT';
    } else if (count === 0) {
        return 'NO_VAULTS';
    }
    return 'VAULTS';
};

export const applicationsCount: CountedTranslation = (count: number) => {
    if (count === 1) {
        return 'ONE_APPLICATION';
    } else if (count === 0) {
        return 'NO_APPLICATIONS';
    }
    return 'APPLICATIONS';
};

export const usersCount: CountedTranslation = (count: number) => {
    if (count === 1) {
        return 'ONE_USER';
    } else if (count === 0) {
        return 'NO_USERS';
    }
    return 'USERS';
};


export const groupsCount: CountedTranslation = (count: number) => {
    if (count === 1) {
        return 'ONE_GROUP';
    } else if (count === 0) {
        return 'NO_GROUPS';
    }
    return 'GROUPS';
};

export const rolesCount: CountedTranslation = (count: number) => {
    if (count === 1) {
        return '';
    } else if (count === 0) {
        return 'NO_ROLES';
    }
    return 'ROLES';
};


export const countText = (count: number, member: string): string => {
    return count === 0 || count === 1 ? member : count + ' ' + member;
};
